export default "__VITE_ASSET__29dd720e__"